
import AdminSidebar from './partials/admin/sidebar'

export default {
  components:{
    AdminSidebar
  }
}
